module.exports = __webpack_public_path__ + "static/img/13.b09796f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/znhy/13.jpg
// module id = 4BJ7
// module chunks = 1